import { useState } from 'react';
import BarkGuide from './BarkGuide';
import WxPluginGuide from './WxPluginGuide';
import { getPreferredSetupGuideTab } from './setupGuideStatus';
import './SetupGuide.css';

const SETUP_TABS = [
  {
    id: 'wxPlugin',
    label: '微信插件',
    hint: 'Android 推荐'
  },
  {
    id: 'bark',
    label: 'Bark',
    hint: 'iOS 推荐'
  }
];

function SetupGuide({ onComplete, onLogout }) {
  const [activeTab, setActiveTab] = useState(getPreferredSetupGuideTab);

  return (
    <div className="setup-guide-page">
      <div className="setup-guide-shell">
        <header className="setup-guide-header">
          <div>
            <h1>完成消息提醒设置</h1>
            <p>
              根据手机系统选择提醒方式。微信插件支持 Android 和 iOS 用户使用；Bark 仅支持 iOS 用户使用。
            </p>
          </div>
          <button className="setup-guide-logout" type="button" onClick={onLogout}>
            退出登录
          </button>
        </header>

        <div className="setup-guide-tabs" role="tablist" aria-label="消息提醒设置方式">
          {SETUP_TABS.map((tab) => (
            <button
              key={tab.id}
              className={`setup-guide-tab ${activeTab === tab.id ? 'active' : ''}`}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              onClick={() => setActiveTab(tab.id)}
            >
              <span>{tab.label}</span>
              <small>{tab.hint}</small>
            </button>
          ))}
        </div>

        <div className="setup-guide-panel" role="tabpanel">
          {activeTab === 'wxPlugin' && (
            <WxPluginGuide embedded onComplete={onComplete} />
          )}
          {activeTab === 'bark' && (
            <BarkGuide embedded onComplete={onComplete} />
          )}
        </div>
      </div>
    </div>
  );
}

export default SetupGuide;
